import type { MicroCMSListContent } from 'microcms-js-sdk';
import type { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { PrivacyPolicyContent } from '@/components/pages/PrivacyPolicy';
import { PrivacyPolicyContentSp } from '@/components/pages/PrivacyPolicySp';
import { Meta } from '@/layouts/Meta';
import { client } from '@/libs/client';
import { Main } from '@/templates/Main';

export type Performance = MicroCMSListContent & {
  term: string;
  description: string;
};

const PrivacyPolicyPage = () => {
  return (
    <Main
      meta={
        <Meta
          title="プライバシーポリシー｜税理士法人奏共同会計事務所"
          description="税理士法人奏共同会計事務所は、資本戦略の実行支援を専門とする日本唯一の税理士法人です。組織再編、事業承継、M&A、国際資本戦略など、企業の成長ステージに応じた先進的なソリューションを提供。高い職業倫理と専門性を持つプロフェッショナル集団として、お客様の経営課題解決を支援します。"
        />
      }
      desktop={<PrivacyPolicyContent />}
      mobile={<PrivacyPolicyContentSp />}
      offsetTop={-1}
    />
  );
};

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  try {
    const res = await client.getList<Performance>({
      endpoint: 'performances',
      queries: { limit: 8 },
    });
    return {
      props: {
        performances: res.contents,
        ...(await serverSideTranslations(locale ?? 'ja', ['common', 'privacy-policy'])),
      },
    };
  } catch (error) {
    console.error('Error in getServerSideProps:', error);
    return {
      props: {
        performances: [],
        ...(await serverSideTranslations(locale ?? 'ja', ['common', 'privacy-policy'])),
      },
    };
  }
};

export default PrivacyPolicyPage;
